import { createFileRoute } from '@tanstack/react-router';

import { PageHeader } from '@/components/ui.tsx';
import { useAuth } from '@/store/auth.ts';
import { ProgressOverviewView } from '@/views/progress/progress-overview-view.tsx';

// Cross-course progress overview. The Next app wrapped this in a max-w-6xl
// container + PageHeader layout; we inline that wrapper here (no nested layout
// route needed for a single page).
export const Route = createFileRoute('/_learner/progress')({
  component: ProgressPage,
});

function ProgressPage() {
  const user = useAuth((s) => s.user);
  if (!user) return null;
  const isTeacher = user.role === 'TEACHER';
  return (
    <div className="mx-auto max-w-6xl px-6 py-10">
      <PageHeader
        title="Progress"
        subtitle={isTeacher ? 'Your teaching workload across courses' : 'Your progress across all courses'}
      />
      <div className="mt-8">
        <ProgressOverviewView user={user} />
      </div>
    </div>
  );
}
